export const NAVIGATION_ROUTES = {
  LOGIN: '/',
  USERS: '/users/home',
  USERS_NEW: '/users-new',
  PLAYERS: '/players',
  USER_MANAGER: '/users/manager',
  SPORTSBOOK: '/sportsbook',
  MAIN_SPORTSBOOK: '/main-sportsbook',
  SPORTSBOOK_BETS_REPORT: '/sportsbook-bets-report',
  KPIS: '/kpis',
  AFFILIATES: '/affiliates',
  ADMIN: '/admin',
  CREATE_ACCOUNT: '/create-account',
  CUSTOMER_SUPPORT_CONTROLS: '/customer-support-controls',
  DASHBOARD: '/dashboard',
  EVENTS: '/events',
  STAFF_MANAGEMENT: '/staff-management',
  AGENT_DASHBOARD: '/agent-dashboard',
  MANUAL_ENTRIES: '/manual-entries',
  PAYMENTS: '/payments',
  FINIX_DELAYED_PAYMENT: '/finix-delayed-payment',
  PRIZE_REDEMPTION_MANUAL_REVIEW: '/prize-redemption-manual-review',
  PRIZE_REDEMPTION_MANUAL_REVIEW_TRACKING:
    '/prize-redemption-manual-review-tracking',
  PROMOTIONS: '/promotions',
  LOCATIONS_RESTRICTIONS: '/locations-restrictions',
  CASINO_FM: '/configurations/casino-fm',
  SPORTSBOOK_FM: '/configurations/sportsbook-fm',
  REPORTS: '/reports',
  MARKETING_AFFILIATES: '/marketing-affiliates',
  CASINO: '/casino',
  PROMOTIONS_MANAGEMENT: '/promotions-management',
  TRANSACTIONS_PROCESSORS: '/transactions-processors',
  TRANSACTIONS_WALLET: '/transactions-wallet',
  TRANSACTIONS_OVERVIEW: '/transactions-overview',
  TRANSACTIONS_REPORTS: '/transactions-reports',
  EVENT_DETAILS: '/event-details',
  BETS_TYPES_LIST: '/bets-types-list',
  WITHDRAWAL_REVIEW: '/withdrawal-review',
  WITHDRAWAL_REVIEW_RULES: '/withdrawal-review/rules',
  WITHDRAWAL_REVIEW_ADD_RULE: '/withdrawal-review/rules/add',
  WITHDRAWAL_REVIEW_EDIT_RULE: '/withdrawal-review/rules/edit',
};
